// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__9ueLK","item":"style_item__ZyWzu"};